import { AccountSetupIdentityEntity } from "@/domain/entity/app-account-setting/account-setup-identity-entity";
import { AccountSetupIdentityResponseDto } from "../dto/account-setup-identity-response-dto";
import { assertAccountSetupIdentityResponseDto } from "@/utils/validation/generated/account-setup-identity-response-dto.validator";

export class AccountSetupIdentityMapper {
  static toEntity(dto: AccountSetupIdentityResponseDto): AccountSetupIdentityEntity {
    assertAccountSetupIdentityResponseDto(dto);
    return {
      hospitalName: dto.hospitalName,
      guardianFullName: dto.guardianFullName,
      patientFullName: dto.patient.fullName,
      patientBirthDate: dto.patient.birthDate,
    };
  }
}
